import { triggerDataLayerOnPageView, triggerPurchaseEcomEvent } from './googleAnalytics';
import {
  addLoyaltyData,
  discountCalculator,
  getMembershipDiscount,
  getOrderContent,
  getProductCategories,
  getProductType
} from './helper';

export const viewItemListGA4 = (categoryData, login) => {
  const ecommerce = { items: [] };
  if (categoryData?.result) {
    categoryData?.result?.product_list?.map((product, idx) =>
      ecommerce.items.push({
        item_id: product.id,
        item_name: product.model_name,
        coupon: '',
        affiliation: '',
        currency: product?.prices[0]?.currency_code,
        discount: discountCalculator(product?.prices),
        index: idx + 1,
        item_brand: product?.brand_name,
        item_category: getProductType(product.sku),
        item_categoy2: '',
        item_categoy3: '',
        item_categoy4: '',
        item_categoy5: '',
        item_list_id: categoryData?.result?.categoryId,
        item_list_name: categoryData?.result?.category_name,
        item_variant: product.color,
        price: product?.prices?.filter(priceObj => priceObj.name === 'Lenskart Price')[0]?.price,
        quantity: 1,
      })
    );
  } else {
    categoryData?.product_list?.map((product, idx) =>
      ecommerce.items.push({
        item_id: product.id,
        item_name: product.model_name,
        coupon: '',
        affiliation: '',
        currency: product?.prices[0]?.currency_code,
        discount: discountCalculator(product?.prices),
        index: idx,
        item_brand: product?.brand_name,
        item_category: getProductType(product.sku),
        item_categoy2: '',
        item_categoy3: '',
        item_categoy4: '',
        item_categoy5: '',
        item_list_id: categoryData?.categoryId,
        item_list_name: categoryData?.category_name,
        item_variant: product.color || '',
        price: product?.prices?.filter(priceObj => priceObj.name === 'Lenskart Price')[0]?.price,
        quantity: 1,
      })
    );
  }
  triggerDataLayerOnPageView({ loginStatus: login, ecommerce });
};

export const viewItemGA4 = (productData, login) => {
  const ecommerce = { items: [] };
  const product = {
    item_id: productData.id,
    item_name: productData.modelName,
    coupon: '',
    alliliation: '',
    currency: productData?.prices[0]?.currencyCode,
    discount: discountCalculator(productData?.prices),
    index: 0,
    item_brand: productData.brandName,
    item_category: getProductType(productData.sku),
    item_category2: '',
    item_category3: '',
    item_category4: '',
    item_category5: '',
    item_list_id: '',
    item_list_name: '',
    item_variant: productData?.frameColour || productData?.frameColor || '',
    price: productData?.prices?.filter(priceObj => priceObj.name === 'Lenskart Price')[0]?.price,
    quantity: 1,
  };
  ecommerce.items.push(product);
  triggerDataLayerOnPageView({ loginStatus: login, ecommerce, event: 'view_item' });
};

export const addToWishListGA4 = (item, login) => {
  const ecommerce = {
    currency: item?.prices[0]?.currencyCode || item?.prices[0]?.currency_code,
    value: '', // to be discussed
    items: [],
  };
  ecommerce.items.push({
    item_id: item?.id,
    item_name: item?.name || item?.fullName || item?.model_name,
    affiliation: '',
    coupon: '',
    currency: item?.prices[0]?.currencyCode || item?.prices[0]?.currency_code,
    discount: item?.prices ? discountCalculator(item.prices) : '',
    index: 0,
    item_brand: item?.brandName || item?.brand_name,
    item_category: getProductType(item?.sku || ''),
    item_category2: '',
    item_category3: '',
    item_category4: '',
    item_category5: '',
    item_list_id: '',
    item_list_name: '',
    item_variant: item?.frameColour || item?.frameColor || '',
    price:
      item?.amount?.total ||
      item?.prices?.filter(priceObj => priceObj.name === 'Lenskart Price')[0].price ||
      '',
    quantity: 1,
  });
  triggerDataLayerOnPageView({ loginStatus: login, ecommerce, event: 'add_to_wishlist' });
};

export const addToCartGA4 = (cartItems, loginStatus) => {
  if (cartItems.length > 0) {
    const ecommerce = { items: [] };
    cartItems.map((item, idx) => {
      ecommerce.items.push({
        item_id: item.productId,
        item_name: item.name || item.fullName || item.modelName,
        affiliation: '',
        coupon: '',
        currency: item?.amount?.currencyCode,
        discount: discountCalculator(item.catalogPrices),
        index: idx,
        item_category: getProductType(item.sku),
        item_category5: '',
        item_list_id: '',
        item_list_name: '',
        item_variant: item.frameColor || item.frameColour || '',
        location_id: '',
        price: item?.amount?.total,
        quantity: item.quantity,
      });
      getProductCategories(item, ecommerce.items[ecommerce.items.length - 1]);
      return null;
    });
    triggerDataLayerOnPageView({ loginStatus, ecommerce, event: 'add_to_cart' });
  }
};

export const removeFromCartGA4 = (item, loginStatus) => {
  const ecommerce = { items: [] };

  ecommerce.items.push({
    item_id: item.productId,
    item_name: item.name || item.fullName || item.modelName,
    affiliation: '',
    coupon: '',
    currency: item?.amount?.currencyCode,
    discount: discountCalculator(item.catalogPrices),
    index: 0,
    item_category: getProductType(item.sku),
    item_category5: '',
    item_list_id: '',
    item_list_name: '',
    item_variant: item.frameColor || item.frameColour || '',
    location_id: '',
    price: item?.amount?.total,
    quantity: item.quantity,
  });
  getProductCategories(item, ecommerce.items[ecommerce.items.length - 1]);
  triggerDataLayerOnPageView({ loginStatus, ecommerce, event: 'remove_from_cart' });
};

export const viewCartGA4 = (cartData, loginStatus) => {
  const ecommerce = {
    currency: cartData?.currencyCode,
    value: cartData?.totals?.total,
    items: [],
  };
  cartData.items.map((item, idx) => {
    const product = {
      item_id: item.productId,
      item_name: item.name,
      coupon: '',
      alliliation: '',
      currency: cartData?.currencyCode,
      discount: discountCalculator(item.catalogPrices),
      index: idx,
      item_brand: item.brandName,
      item_category: getProductType(item.sku),
      item_category5: '',
      item_list_id: '',
      item_list_name: '',
      item_variant: item.frameColor || item.frameColour || '',
      price: item?.amount?.total,
      quantity: item.quantity,
    };
    getProductCategories(item, product);
    ecommerce.items.push(product);
    return null;
  });
  triggerDataLayerOnPageView({ loginStatus, ecommerce, event: 'view_cart' });
};

export const beginCheckoutGA4 = (cartData, loginStatus) => {
  const ecommerce = {
    items: [],
  };
  if (cartData?.result) {
    cartData?.result?.items?.map((item, idx) => {
      const product = {
        item_id: item.productId,
        item_name: item.name,
        coupon: '',
        alliliation: '',
        currency: cartData?.result?.currencyCode,
        discount: discountCalculator(item.catalogPrices),
        index: idx,
        item_brand: item.brandName,
        item_category: getProductType(item.sku),
        item_category5: '',
        item_list_id: '',
        item_list_name: '',
        item_variant: item.frameColor || item.frameColour || '',
        price: item?.amount?.total,
        quantity: item.quantity,
      };
      getProductCategories(item, product);
      ecommerce.items.push(product);
      return null;
    });
  } else {
    cartData?.items?.map(item => {
      const product = {
        item_id: item.productId,
        item_name: item.name,
        coupon: '',
        alliliation: '',
        currency: cartData?.currencyCode,
        discount: discountCalculator(item.catalogPrices),
        index: 0,
        item_brand: item.brandName,
        item_category: getProductType(item.sku),
        item_category5: '',
        item_list_id: '',
        item_list_name: '',
        item_variant: item.frameColor || item.frameColour || '',
        price: item?.amount?.total,
        quantity: item.quantity,
      };
      getProductCategories(item, product);
      ecommerce.items.push(product);
      return null;
    });
  }
  triggerDataLayerOnPageView({ loginStatus, ecommerce, event: 'begin_checkout' });
};

export const addShippingInfoGA4 = (cartData, loginStatus) => {
  const ecommerce = {
    currency: cartData.currencyCode,
    value: cartData?.totals?.total,
    coupon: '',
    shopping_tier: '',
    items: [],
  };
  cartData?.items?.map((item, idx) => {
    ecommerce.items.push({
      item_id: item.productId,
      item_name: item.name,
      coupon: '',
      alliliation: '',
      currency: cartData.currencyCode,
      discount: discountCalculator(item.catalogPrices),
      index: idx,
      item_brand: item.brandName,
      item_category: getProductType(item.sku),
      item_category5: '',
      item_list_id: '',
      item_list_name: '',
      item_variant: item?.frameColor || item?.frameColour || '',
      location_id: '',
      price: item?.amount?.total,
      quantity: item?.quantity,
    });
    getProductCategories(item, ecommerce.items[ecommerce.items.length - 1]);
    return null;
  });
  triggerDataLayerOnPageView({ loginStatus, ecommerce, event: 'add_shipping_info' });
};

export const addPaymentInfoGA4 = (cartData, paymentType, loginStatus) => {
  const ecommerce = {
    currency: cartData.currencyCode,
    value: cartData?.totals?.total,
    membership_discount: getMembershipDiscount(cartData),
    coupon_discount: '',
    coupon: '',
    payment_type: paymentType,
    items: [],
  };
  cartData?.items?.map((item, idx) => {
    ecommerce.items.push({
      item_id: item.productId,
      item_name: item.name,
      coupon: '',
      currency: cartData.currencyCode,
      discount: discountCalculator(item.catalogPrices),
      index: idx,
      item_brand: item.brandName,
      item_category: getProductType(item.sku),
      item_variant: item?.frameColor || item?.frameColour || '',
      price: item?.amount?.total,
      quantity: item?.quantity,
    });
    getProductCategories(item, ecommerce.items[ecommerce.items.length - 1]);
    return null;
  });
  triggerDataLayerOnPageView({ loginStatus, ecommerce, event: 'add_payment_info' });
};

export const purchaseInfoGA4 = (order, userInfo) => {
  const ecommerce = {
    currency: order?.amount?.currencyCode,
    transaction_id: order?.id,
    value: order?.amount?.total,
    tax: order?.amount?.totalTax,
    shipping: order?.amount?.shipping,
    membership_discount: order?.amount?.discounts[0]?.type === 'implicit' ? order?.amount?.discounts[0]?.amount : '',
    coupon_discount: order?.amount?.discounts[0]?.type === 'gv' ? order?.amount?.discounts[0]?.amount : '',
    coupon: order?.amount?.discounts[0]?.type === 'gv' ? order?.amount?.discounts[0]?.code : '',
    payment_mode: order?.payments?.paymentList[0]?.method,
    items: [],
  };
  order?.items?.map((item, idx) => {
    ecommerce.items.push({
      item_id: item?.productId,
      item_name: item?.name,
      currency: order?.amount?.currencyCode,
      discount: discountCalculator(item?.catalogPrices),
      index: idx,
      item_brand: item?.brandName,
      item_category: getProductType(item?.sku),
      item_variant: item?.frameColor || item?.frameColour || '',
      price: item?.amount?.total,
      quantity: item?.quantity,
    });
    getProductCategories(item, ecommerce.items[ecommerce.items.length - 1]);
    return null;
  });
  const eventData = {
    ecommerce,
    event: 'purchase',
    order_content: getOrderContent(order),
    delivery_option: order?.deliveryOption,
    gokwik_risk_flag: order?.gokwikRtoDetails?.riskFlag?.split(' ')[0]?.toLowerCase(),
    gokwik_order_type: order?.payments?.paymentList[0]?.method,
    last_order_city: order?.shippingAddress?.city,
    number_of_items: order?.items?.length,
    last_transaction_date: new Date(order?.createdAt)
      ? new Date(order?.createdAt).toLocaleString('sv').split(' ')[0]
      : '',
  };
  addLoyaltyData(order, userInfo, eventData);
  triggerPurchaseEcomEvent(eventData);
};
